import InfoBox from './InfoBox';

export default InfoBox;



// WEBPACK FOOTER //
// ./src/components/InfoBox/index.js